import React from 'react'
import { Button, Icon, Row, Col, Result } from 'antd';
import { withNamespaces } from 'react-i18next';


const ResultsComponent = (props) => {
    return (
        <Row type="flex" align="middle" justify="center">
            <Col style={{ maxWidth: '600px' }}>
                <Result
                  status="success"
                  title={props.i18n.t('NamespaceResultsAdmin:Randomization has been completed successfully. Please see details below!')}
                  subTitle={<div>
                    {props.i18n.t('Subject ID')}: {props.studyID}.
                    <br/>
                    {props.i18n.t('Date and Time')}: {props.date}
                    <br/>
                    <span style={{ fontWeight: 'bold', fontSize: '1.1rem', color: "#666" }}>{props.i18n.t('Drug #')}: {props.bottle_no}</span>
                    <br/>
                    {props.i18n.t('Drug volume')}: {props.dose} ml
                    <br/><br/>
                    <p><Button onClick={props.onBackClick}><Icon type="arrow-left" />{props.i18n.t('Back')}</Button></p>
                  </div>}>

                  {/*<p>Date and Time: {props.date}</p>*/}
                  {/*<Button type='primary' onClick={props.onBackClick}><Icon type="arrow-left" />Back</Button>*/}
                </Result>
                {/*<h5 className='headline-default'>Date and Time: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.date}</span></h5>*/}
                {/*<h6 className='headline-default' style={{ marginTop: '1rem', color: 'var(--primary-color)' }} onClick={props.onBackClick}><Icon type="arrow-left" style={{ marginRight: '0.5rem' }} />Back</h6>*/}
            </Col>
        </Row>
    )
}

export const Results = withNamespaces()(ResultsComponent);



// WEBPACK FOOTER //
// ./src/components/Results/ResultsAdmin.js